export default {
	inProcessDev: `The page is under construction! <br/> You will soon be able to use all its functions. <br/> <strong> Thanks for your understanding </strong>`,
}